import { createSlice } from '@reduxjs/toolkit';

interface IWorkflowDeptState {
    departments: string[];
    selectedDepartment: string;
}

const initialState: IWorkflowDeptState = {
    departments: [],
    selectedDepartment: ""
  };

  const workflowDeptSlice = createSlice({
    name: 'workflow-dept',
    initialState,
    reducers: {
      addWorkflowDepartments(state, action){
        state.departments = action.payload;
      },
      setWorkflowDepartment(state, action){
        state.selectedDepartment = action.payload;
      }
    }
  });
  
  export const { addWorkflowDepartments, setWorkflowDepartment } = workflowDeptSlice.actions;
  export default workflowDeptSlice.reducer;